export default __webpack_public_path__ + "static/media/Slider_4500_Web.22c49a47.webp";